import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquareIcon, CalendarIcon, FileTextIcon } from 'lucide-react';
export function BenefitsSection() {
  const services = [{
    icon: MessageSquareIcon,
    title: 'Automatización de WhatsApp',
    description: 'Respuestas automáticas 24/7, calificación de leads, y seguimiento sin intervención humana. Las PYMES pierden clientes cada día por no responder a tiempo.'
  }, {
    icon: CalendarIcon,
    title: 'Sistema de Citas Automatizado',
    description: 'Agenda, confirma y reagenda citas sin secretaria. Perfecto para dentistas, abogados, salones de belleza y cualquier negocio de servicios.'
  }, {
    icon: FileTextIcon,
    title: 'Creación de Contenido 24/7',
    description: 'Posts para redes sociales, emails de marketing, y descripciones de productos generados en segundos. Los dueños de negocios odian crear contenido.'
  }];
  return <section className="w-full bg-slate-900 py-20 px-4" data-id="element-8">
      <div className="max-w-6xl mx-auto" data-id="element-9">
        <motion.h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-6" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-10">
          3 Servicios de IA que las empresas{' '}
          <span className="text-gold-400" data-id="element-11">mueren por contratar</span>
        </motion.h2>

        <motion.p className="text-xl text-gray-300 text-center mb-16 max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-12">
          (Y cómo entregarlos sin programar una sola línea de código)
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-13">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={service.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6,
            delay: 0.1 * index
          }} className="bg-gradient-to-br from-slate-800 to-slate-700 border border-teal-500/30 rounded-xl p-8 hover:border-gold-400/50 transition-all duration-300" data-id="element-14">
                <div className="w-16 h-16 bg-teal-500/20 rounded-lg flex items-center justify-center mb-6" data-id="element-15">
                  <Icon className="w-8 h-8 text-teal-400" data-id="element-16" />
                </div>
                <h3 className="font-heading text-2xl font-bold text-gold-400 mb-4" data-id="element-17">
                  {service.title}
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-18">
                  {service.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}